/*
 * Default Router
 */

// Vue and Vue Router
import Vue from "vue";
import Router from "vue-router";
import hasPermission from "../router/middleware";

// Main layouts CollegeBackend
import LayoutBackend from "@/layouts/variations/Backend.vue";
import LayoutSimple from "@/layouts/variations/Simple.vue";

// Register Vue Router
Vue.use(Router);

// Backend: General
const Dashboard = () =>
  import(
    /* webpackChunkName: "pages-dashboard", webpackPrefetch: true */ "@/views/Dashboard.vue"
  );
const CollegeDashboard = () => import("@/views/CollegeDashboard.vue");
const LayoutLoaders = () => import("@/views/layout/Loaders.vue");

// Backend: Tables
const TablesUser = () => import("@/views/tables/User.vue");
const EBoxUser = () => import("@/views/tables/Ebox.vue");
const TablesCollegeUser = () => import("@/views/tables/CollegeUser.vue");
const TablesCollegePurchaseSubscription = () =>
  import("@/views/tables/CollegePurchaseSubscription.vue");
const TablesCollegePurchaseHod = () =>
  import("@/views/tables/CollegePurchaseHod.vue");
const TablesCollegePurchaseClass = () =>
  import("@/views/tables/CollegePurchaseClass.vue");
const TablesCollegePurchaseStudent = () =>
  import("@/views/tables/CollegePurchaseStudent.vue");
const TablesCollegePurchaseDepartment = () =>
  import("@/views/tables/CollegePurchaseDepartment.vue");
const TablesCollegePurchaseDepartmentHod = () =>
  import("@/views/tables/CollegePurchaseDepartmentHod.vue");
const TablesCollegePurchaseDepartmentHodClass = () =>
  import("@/views/tables/CollegePurchaseDepartmentHodClass.vue");
const TablesCollegePurchaseDepartmentHodClassStudent = () =>
  import("@/views/tables/CollegePurchaseDepartmentHodClassStudent.vue");
const TablesCollegeSubscriptionVideos = () =>
  import("@/views/tables/CollegeSubscriptionVideos.vue");
const TablesCollegeSubscriptionStudents = () =>
  import("@/views/tables/CollegeSubscriptionStudents.vue");
const TablesCollegeSubscriptionVideosChild = () =>
  import("@/views/tables/CollegeSubscriptionVideosChild.vue");
const TablesCollegeSubscriptionPracticeTests = () =>
  import("@/views/tables/CollegeSubscriptionPracticeTests.vue");
const TablesCollegeSubscriptionPracticeTestsChild = () =>
  import("@/views/tables/CollegeSubscriptionPracticeTestsChild.vue");
const TablesCollegeSubscriptionPracticeTestsChildTopic = () =>
  import("@/views/tables/CollegeSubscriptionPracticeTestsChildTopic.vue");
const TablesCollegeSubscriptionPracticeTestsChildTopicTest = () =>
  import("@/views/tables/CollegeSubscriptionPracticeTestsChildTopicTest.vue");

const TablesCollegeSubscriptionMockTest = () =>
  import("@/views/tables/CollegeSubscriptionMockTest.vue");
const TablesCollegeSubscriptionMockTestTopic = () =>
  import("@/views/tables/CollegeSubscriptionMockTestTopic.vue");
const TableProfile = () => import("@/views/tables/Profile.vue");
const TableCollegeUserProfile = () =>
  import("@/views/tables/CollegeUserProfile.vue");
const TableRole = () => import("@/views/tables/Roles.vue");
const TableAdmin = () => import("@/views/tables/Admin.vue");
const TableCategory = () => import("@/views/tables/Category.vue");
const TableStates = () => import("@/views/tables/States.vue");
const TablesBanners = () => import("@/views/tables/Banners.vue");
const TablesLibrary = () => import("@/views/tables/Library.vue");
const TablesVideoSessions = () => import("@/views/tables/VideoSessions.vue");
const TablesTopic = () => import("@/views/tables/Topics.vue");
const TablesQuestions = () => import("@/views/tables/Questions.vue");
const TablesVideo = () => import("@/views/tables/Video.vue");
const TablesTests = () => import("@/views/tables/Tests.vue");
const TablesTestTopics = () => import("@/views/tables/TestTopics.vue");
const TablesUserTestReports = () =>
  import("@/views/tables/UserTestReports.vue");
const TableCollegeUserTestReport = () =>
  import("@/views/tables/CollegeUserTestReports.vue");
const TablesTestDetails = () => import("@/views/tables/TestDetails.vue");
const DailyTestDetails = () => import("@/views/tables/DailyTestdetails.vue");
const TablesTestDetailsMockTest = () =>
  import("@/views/tables/TestDetailsMockTest.vue");
const TablesTestDetailsPracticeTest = () =>
  import("@/views/tables/TestDetailsPracticeTest.vue");
const TablesTestDetailsCompiler = () =>
  import("@/views/tables/TestDetailsCompiler.vue");
const TestDetailsAllIndiaMockTest = () =>
  import("@/views/tables/TestDetailsAllIndiaMockTest.vue");
const TablesDailyChallenge = () => import("@/views/tables/DailyChallenge.vue");
const TablesAllIndiaMockTest = () =>
  import("@/views/tables/AllIndiaMockTest.vue");
const TablesRecruitmentDriveTest = () =>
  import("@/views/tables/RecruitmentDriveTest.vue");
const TablesSubscriptions = () => import("@/views/tables/Subscriptions.vue");
const TablesDiscussions = () => import("@/views/tables/Discussions.vue");
const TablesChats = () => import("@/views/tables/Chats.vue");
const TablesNotifications = () => import("@/views/tables/Notifications.vue");
const TablesColleges = () => import("@/views/tables/Colleges.vue");
const TablesCollegeSubscriptions = () =>
  import("@/views/tables/CollegeSubscriptions.vue");
const TablesNotifyMe = () => import("@/views/tables/NotifyMe.vue");
const TablesHelp = () => import("@/views/tables/Help.vue");
const TablesFeedbacks = () => import("@/views/tables/Feedbacks.vue");
const TablesCollegeSubscriptionUserList = () =>
  import("@/views/tables/CollegeSubscriptionUserList.vue");
const TablesUpcommingDrives = () =>
  import("@/views/tables/UpcommingDrives.vue");
const TablesCollegeProfile = () => import("@/views/tables/CollegeProfile.vue");
const SubscriptionMockTest = () =>
  import("@/views/tables/SubscriptionMockTest.vue");
const SubscriptionPracticeTest = () =>
  import("@/views/tables/SubscriptionPracticeTest.vue");
const SubscriptionCompiler = () =>
  import("@/views/tables/SubscriptionCompiler.vue");
const SubscriptionVideos = () =>
  import("@/views/tables/SubscriptionVideos.vue");
const MCQView = () => import("@/views/tables/MCQView.vue");
const GroupView = () => import("@/views/tables/GroupView.vue");
const UserTestQuestionsAnswer = () =>
  import("@/views/tables/UserTestQuestionsAnswer.vue");
const AllTestReports = () => import("@/views/tables/AllTestReports.vue");
const AllUserTestReports = () =>
  import("@/views/tables/AllUserTestReports.vue");
const AllUserTestReportsSub = () =>
  import("@/views/tables/AllUserTestReportsSub.vue");
const AppVersions = () => import("@/views/tables/Versions.vue");
const CollegeAllTestReports = () =>
  import("@/views/tables/CollegeAllTestReports.vue");
const CollegeAllDepartmentTestReports = () =>
  import("@/views/tables/CollegeAllDepartmentTestReports.vue");
const CollegeAllHodTestReports = () =>
  import("@/views/tables/CollegeAllHodTestReports.vue");
const CollegeAllClassTestReports = () =>
  import("@/views/tables/CollegeAllClassTestReports.vue");
const CollegeUserTestAttended = () =>
  import("@/views/tables/CollegeUserTestAttended.vue");

//Backend: Forms
const AddRole = () => import("@/views/forms/AddRole.vue");
const EditRole = () => import("@/views/forms/EditRole.vue");
const AddAdmin = () => import("@/views/forms/AddAdmin.vue");
const EditUser = () => import("@/views/forms/EditUser.vue");
const EditStudent = () => import("@/views/forms/EditStudent.vue");
const AddCategory = () => import("@/views/forms/AddCategory.vue");
const AddBanner = () => import("@/views/forms/AddBanner.vue");
const AddEBoxUser = () => import("@/views/forms/AddEBoxUser.vue");
const AddLibrary = () => import("@/views/forms/AddLibrary.vue");
const EditLibrary = () => import("@/views/forms/EditLibrary.vue");
const EditVideoSessions = () => import("@/views/forms/EditVideoSession.vue");
const AddVideoSessions = () => import("@/views/forms/AddVideoSession.vue");
const AddTopic = () => import("@/views/forms/AddTopic.vue");
const EditTopic = () => import("@/views/forms/EditTopic.vue");
const AddQuestion = () => import("@/views/forms/AddQuestion.vue");
const EditQuestion = () => import("@/views/forms/EditQuestion.vue");
const AddState = () => import("@/views/forms/AddState.vue");
const AddVideo = () => import("@/views/forms/AddVideo.vue");
const EditTests = () => import("@/views/forms/EditTests.vue");
const EditTestTopic = () => import("@/views/forms/EditTestTopic.vue");
const AddBulkQuestions = () => import("@/views/forms/AddBulkQuestions.vue");
const AddGroupQuestions = () => import("@/views/forms/AddGroupQuestions.vue");
const AddDailyChallenge = () => import("@/views/forms/AddDailyChallenge.vue");
const AddAllIndiaMockTest = () =>
  import("@/views/forms/AddAllIndiaMockTest.vue");
const AddRecruitmentDriveTest = () =>
  import("@/views/forms/AddRecruitmentDriveTest.vue");
const AddSubscriptions = () => import("@/views/forms/AddSubscriptions.vue");
const AddSubscriptionVideos = () =>
  import("@/views/forms/AddSubscriptionVideos.vue");
const AddPracticeTest = () => import("@/views/forms/AddPracticeTest.vue");
const AddCompiler = () => import("@/views/forms/AddCompiler.vue");
const AddMockTest = () => import("@/views/forms/AddMockTest.vue");
const DiscussionSummary = () => import("@/views/forms/DiscussionSummary.vue");
const AddCollege = () => import("@/views/forms/AddCollege.vue");
const AddCollegeSubscriptions = () =>
  import("@/views/forms/AddCollegeSubscriptions.vue");
const AddNotifyMe = () => import("@/views/forms/AddNotifyMe.vue");
const AddNotification = () => import("@/views/forms/AddNotification.vue");
const AddUpcommingDrives = () => import("@/views/forms/AddUpcommingDrives.vue");
const MapSubscription = () => import("@/views/forms/MapSubscription.vue");
const EditCategory = () => import("@/views/forms/EditCategory.vue");
const EditState = () => import("@/views/forms/EditState.vue");
const EditBanner = () => import("@/views/forms/EditBanner.vue");
const EditGroupQuestion = () => import("@/views/forms/EditGroupQuestion.vue");
const EditVideo = () => import("@/views/forms/EditVideo.vue");
const EditCollege = () => import("@/views/forms/EditCollege.vue");
const EditUpcommingDrives = () =>
  import("@/views/forms/EditUpcommingDrives.vue");
const EditSubscription = () => import("@/views/forms/EditSubscription.vue");
const ViewTestQuestions = () => import("@/views/forms/ViewTestQuestions.vue");
const ViewDailyTestQuestions = () =>
  import("@/views/forms/ViewDailyTestQuestions.vue");
const ViewTestQuestionsmockTest = () =>
  import("@/views/forms/ViewTestQuestionsmockTest.vue");
const EditAdmin = () => import("@/views/forms/EditAdmin.vue");
const ViewTestQuestionsPracticeTest = () =>
  import("@/views/forms/ViewTestQuestionsPracticeTest.vue");
const ViewTestQuestionsCompiler = () =>
  import("@/views/forms/ViewTestQuestionsCompiler.vue");

// Backend: Auth Pages
const PagesAuthAll = () => import("@/views/pages/auth/All.vue");

// Backend: Error Pages
const PagesErrorsAll = () => import("@/views/pages/errors/All.vue");

// Pages: Auth
const AuthSignIn = () =>
  import(/* webpackChunkName: "auth-signin" */ "@/views/pages/auth/SignIn.vue");
const CollegeAuthSignIn = () =>
  import(
    /* webpackChunkName: "auth-signin" */ "@/views/pages/auth/CollegeSignIn.vue"
  );
const AuthReminder = () =>
  import(
    /* webpackChunkName: "auth-r  eminder" */ "@/views/pages/auth/Reminder.vue"
  );

// Pages: Errors
const Errors400 = () => import("@/views/pages/errors/400.vue");
const Errors401 = () => import("@/views/pages/errors/401.vue");
const Errors403 = () => import("@/views/pages/errors/403.vue");
const Errors404 = () => import("@/views/pages/errors/404.vue");
const Errors500 = () => import("@/views/pages/errors/500.vue");
const Errors503 = () => import("@/views/pages/errors/503.vue");

// Router Configuration
export default new Router({
  linkActiveClass: "active",
  linkExactActiveClass: "",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: LayoutSimple,
      children: [
        {
          path: "/",
          name: "Sign In",
          component: AuthSignIn,
        },
        {
          path: "college/:collegeName/:collegeId/signin",
          name: "College Sign In",
          component: CollegeAuthSignIn,
        },
        {
          path: "reminder",
          name: "Auth Reminder",
          component: AuthReminder,
        },
      ],
    },
    {
      path: "/errors",
      component: LayoutSimple,
      children: [
        {
          path: "400",
          name: "Error 400",
          component: Errors400,
        },
        {
          path: "401",
          name: "Error 401",
          component: Errors401,
        },
        {
          path: "403",
          name: "Error 403",
          component: Errors403,
        },
        {
          path: "404",
          name: "Error 404",
          component: Errors404,
        },
        {
          path: "500",
          name: "Error 500",
          component: Errors500,
        },
        {
          path: "503",
          name: "Error 503",
          component: Errors503,
        },
      ],
    },
    {
      path: "/backend",
      redirect: "/backend/dashboard",
      component: LayoutBackend,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          beforeEnter: hasPermission,
          meta: { permission: "CAN_SEE_DASHBOARD" },
        },
        {
          path: "college/:collegeName/dashboard",
          name: "College Dashboard",
          component: CollegeDashboard,
        },
        {
          path: "layout",
          redirect: "/layout/api",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "loaders",
              name: "Loaders",
              component: LayoutLoaders,
            },
          ],
        },
        {
          path: "tables",
          redirect: "/tables/styles",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "college/:collegeName/users",
              name: "College Users",
              component: TablesCollegeUser,
            },
            {
              path: "college/:collegeName/subscriptions",
              name: "College Purchase Subscription",
              component: TablesCollegePurchaseSubscription,
            },
            {
              path: "college/:collegeName/departments",
              name: "College Purchase Department",
              component: TablesCollegePurchaseDepartment,
            },
            {
              path: "college/:collegeName/hods",
              name: "College Purchase Hod",
              component: TablesCollegePurchaseHod,
            },
            {
              path: "college/:collegeName/classes",
              name: "College Purchase Class",
              component: TablesCollegePurchaseClass,
            },
            {
              path: "college/:collegeName/students",
              name: "College Purchase Student",
              component: TablesCollegePurchaseStudent,
            },
            {
              path: "college/:collegeName/departments/hod/:id",
              name: "College Purchase Department Hod",
              component: TablesCollegePurchaseDepartmentHod,
            },
            {
              path: "college/:collegeName/departments/hod/class/:id",
              name: "College Purchase Department Hod Class",
              component: TablesCollegePurchaseDepartmentHodClass,
            },
            {
              path: "college/:collegeName/departments/hod/class/student/:id",
              name: "College Purchase Department Hod Class Student",
              component: TablesCollegePurchaseDepartmentHodClassStudent,
            },
            {
              path: "college/:collegeName/college_subscription_videos/:id",
              name: "College Subscription Videos",
              component: TablesCollegeSubscriptionVideos,
            },
            {
              path: "college/:collegeName/college_subscription_students/:id",
              name: "College Subscription Students",
              component: TablesCollegeSubscriptionStudents,
            },
            {
              path:
                "college/:collegeName/college_subscription_videos_child/:subId/:id",
              name: "College Subscription Videos Child",
              component: TablesCollegeSubscriptionVideosChild,
            },
            {
              path:
                "college/:collegeName/college_subscription_practice_tests/:id",
              name: "College Subscription Practice Tests",
              component: TablesCollegeSubscriptionPracticeTests,
            },
            {
              path:
                "college/:collegeName/college_subscription_practice_tests_child/:subId/:id",
              name: "College Subscription Pratice Tests Child",
              component: TablesCollegeSubscriptionPracticeTestsChild,
            },
            {
              path:
                "college/:collegeName/college_subscription_practice_tests_child/:subId/:id",
              name: "College Subscription Pratice Tests Child Topic",
              component: TablesCollegeSubscriptionPracticeTestsChildTopic,
            },
            {
              path:
                "college/:collegeName/college_subscription_practice_tests_child/:id",
              name: "College Subscription Pratice Tests Child Topic Test",
              component: TablesCollegeSubscriptionPracticeTestsChildTopicTest,
            },
            {
              path:
                "college/:collegeName/college_subscription_mock_test/:id/:col_sub_id",
              name: "College Subscription Mock Test",
              component: TablesCollegeSubscriptionMockTest,
            },
            {
              path:
                "college/:collegeName/college_subscription_mock_test_topic/:id/:col_sub_id",
              name: "College Subscription Mock Test Topic",
              component: TablesCollegeSubscriptionMockTestTopic,
            },
            {
              path: "college/:collegeName/users/:userId",
              name: "College User Profile",
              component: TableCollegeUserProfile,
            },
            {
              path: "college/:collegeName/users-edit/:userId",
              name: "College User Edit",
              component: EditStudent,
            },
            {
              path: "college/:collegeName/users/:userId/tests/:testId",
              name: "College User Test Report",
              component: TableCollegeUserTestReport,
            },
            {
              path: "college/:collegeName/test_reports",
              name: "College All Test Report",
              component: CollegeAllTestReports,
            },
            {
              path: "college/:collegeName/department_test_reports",
              name: "College All Test Report",
              component: CollegeAllDepartmentTestReports,
            },
            {
              path: "college/:collegeName/hod_test_reports",
              name: "College All Test Report",
              component: CollegeAllHodTestReports,
            },
            {
              path: "college/:collegeName/class_test_reports",
              name: "College All Test Report",
              component: CollegeAllClassTestReports,
            },
            {
              path:
                "college/:collegeName/user_attended/:testId/:collegeAdminId",
              name: "College User Test Attended",
              component: CollegeUserTestAttended,
            },
            {
              path: "user",
              name: "Tables User",
              component: TablesUser,
            },
            {
              path: "EBox",
              name: "EBox User",
              component: EBoxUser,
            },
            {
              path: "college/user",
              name: "Tables College User",
              component: TablesCollegeUser,
            },
            {
              path: "profile/:id",
              name: "Tables Profile",
              component: TableProfile,
            },
            {
              path: "role",
              name: "Tables Role",
              component: TableRole,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_ROLE" },
            },
            {
              path: "admin",
              name: "Tables Admin",
              component: TableAdmin,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_ADMIN" },
            },
            {
              path: "category",
              name: "Tables Category",
              component: TableCategory,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_CATEGORY" },
            },
            {
              path: "states",
              name: "Tables States",
              component: TableStates,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_STATE" },
            },
            {
              path: "banners",
              name: "Tables Banners",
              component: TablesBanners,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_BANNER" },
            },
            {
              path: "library",
              name: "Tables Library",
              component: TablesLibrary,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_LIBRARY" },
            },
            {
              path: "video-sessions",
              name: "Tables VideoSessions",
              component: TablesVideoSessions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_SESSION" },
            },
            {
              path: "topics",
              name: "Tables Topics",
              component: TablesTopic,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_TOPIC" },
            },
            {
              path: "questions",
              name: "Tables Questions",
              component: TablesQuestions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_QUESTION" },
            },
            {
              path: "video",
              name: "Tables Video",
              component: TablesVideo,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_VIDEO" },
            },
            {
              path: "tests",
              name: "Tables Tests",
              component: TablesTests,
            },
            {
              path: "test-topics",
              name: "Tables Test Topics",
              component: TablesTestTopics,
            },
            {
              path: "user-test-reports/:id",
              name: "User Test Reports",
              component: TablesUserTestReports,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_USER" },
            },
            {
              path: "user-test-answers/:id",
              name: "User Test Answers",
              component: UserTestQuestionsAnswer,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_USER" },
            },
            {
              path: "test-details/:name/:id",
              name: "Test Details",
              component: TablesTestDetails,
            },
            {
              path: "daily-test-details/:id",
              name: "Daily Test Details",
              component: DailyTestDetails,
            },
            {
              path: "all-india-mock-test-details/:name/:id",
              name: "All India Mock Test Details",
              component: TestDetailsAllIndiaMockTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_ALL_INDIA_MOCK" },
            },
            {
              path: "test-details-mock-test/:name/:id",
              name: "Test Details Mock Test",
              component: TablesTestDetailsMockTest,
            },
            {
              path: "test-details-practice-test/:subId/:testId",
              name: "Test Details Practice Test",
              component: TablesTestDetailsPracticeTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "test-details-compiler",
              name: "Test Details Compiler",
              component: TablesTestDetailsCompiler,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "daily-challenge",
              name: "Daily Challenge",
              component: TablesDailyChallenge,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_DAILY_CHALLENGE" },
            },
            {
              path: "all-india-mock-test",
              name: "All India Mock Test",
              component: TablesAllIndiaMockTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_ALL_INDIA_MOCK" },
            },
            {
              path: "recruitment-drive-test",
              name: "Recruitment Drive Test",
              component: TablesRecruitmentDriveTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_ONGOING_RECRUITMENT" },
            },
            {
              path: "test-reports",
              name: "All Test Reports",
              component: AllTestReports,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_TEST_REPORT" },
            },
            {
              path: "all-user-test-reports/:id/:date?/:type?",
              name: "All User Test Reports",
              component: AllUserTestReports,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_TEST_REPORT" },
            },
            {
              path: "all-user-test-reports/:id/:date?/:type?/:method?",
              name: "All User Test ReportsSub",
              component: AllUserTestReportsSub,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_TEST_REPORT" },
            },
            {
              path: "subscriptions",
              name: "Subscriptions",
              component: TablesSubscriptions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_SUBSCRIPTION" },
            },
            {
              path: "discussions",
              name: "Discussions",
              component: TablesDiscussions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_DISCUSSION" },
            },
            {
              path: "chats",
              name: "Chats",
              component: TablesChats,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_CHAT" },
            },
            {
              path: "notifications",
              name: "Notifications",
              component: TablesNotifications,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_NOTIFICATION" },
            },
            {
              path: "colleges",
              name: "Colleges",
              component: TablesColleges,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_COLLEGE" },
            },
            {
              path: "college-subscriptions",
              name: "College Subscriptions",
              component: TablesCollegeSubscriptions,
            },
            {
              path: "notify-me",
              name: "Notify Me",
              component: TablesNotifyMe,
            },
            {
              path: "help",
              name: "Help",
              component: TablesHelp,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_HELP" },
            },
            {
              path: "feedbacks",
              name: "Feedbacks",
              component: TablesFeedbacks,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_FEEDBACK" },
            },
            {
              path: "appversions",
              name: "App Version",
              component: AppVersions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_SW_VER" },
            },
            {
              path: "college-subscription-user-list/:id",
              name: "College Subscription User List",
              component: TablesCollegeSubscriptionUserList,
            },
            {
              path: "upcomming-drives",
              name: "Upcomming Drives",
              component: TablesUpcommingDrives,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_UPCOMING_RECRUITMENT" },
            },
            {
              path: "college-profile/:id",
              name: "College Profile",
              component: TablesCollegeProfile,
            },
            {
              path: "subscription-mock-test/:id",
              name: "Subscription Mock Test",
              component: SubscriptionMockTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "subscription-videos/:id",
              name: "Subscription Videos",
              component: SubscriptionVideos,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "subscription-practice-test/:id",
              name: "Subscription Practice Test",
              component: SubscriptionPracticeTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "subscription-compiler",
              name: "Subscription Compiler",
              component: SubscriptionCompiler,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "mcq-view/:id",
              name: "Mcq View",
              component: MCQView,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_QUESTION" },
            },
            {
              path: "group-view/:id",
              name: "Group View",
              component: GroupView,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_QUESTION" },
            },
          ],
        },
        {
          path: "forms",
          redirect: "/forms/elements",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "add-role",
              name: "Add Role",
              component: AddRole,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_ROLE" },
            },
            {
              path: "edit-role/:id",
              name: "Edit Role",
              component: EditRole,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_ROLE" },
            },
            {
              path: "add-admin",
              name: "Add Admin",
              component: AddAdmin,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_ADMIN" },
            },
            {
              path: "edit-user",
              name: "Edit User",
              component: EditUser,
            },
            {
              path: "add-category",
              name: "Add Category",
              component: AddCategory,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_CATEGORY" },
            },
            {
              path: "add-banner",
              name: "Add Banner",
              component: AddBanner,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_BANNER" },
            },
            {
              path: "add-ebox-user",
              name: "Add EBox",
              component: AddEBoxUser,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_BANNER" },
            },
            {
              path: "edit-library",
              name: "Edit Library",
              component: EditLibrary,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_LIBRARY" },
            },
            {
              path: "add-library",
              name: "Add Library",
              component: AddLibrary,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_LIBRARY" },
            },
            {
              path: "edit-video-session/:id",
              name: "Edit Video Session",
              component: EditVideoSessions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_SESSION" },
            },
            {
              path: "add-video-session",
              name: "Add Video Session",
              component: AddVideoSessions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_SESSION" },
            },
            {
              path: "add-topic",
              name: "Add Topic",
              component: AddTopic,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_TOPIC" },
            },
            {
              path: "edit-topic",
              name: "Edit Topic",
              component: EditTopic,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_TOPIC" },
            },
            {
              path: "add-question",
              name: "Add Question",
              component: AddQuestion,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_QUESTION" },
            },
            {
              path: "edit-question/:id",
              name: "Edit Question",
              component: EditQuestion,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_QUESTION" },
            },
            {
              path: "add-bulk-questions",
              name: "Add Bulk Questions",
              component: AddBulkQuestions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_QUESTION" },
            },
            {
              path: "add-state",
              name: "Add State",
              component: AddState,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_STATE" },
            },
            {
              path: "add-video",
              name: "Add Video",
              component: AddVideo,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_VIDEO" },
            },
            {
              path: "edit-tests",
              name: "Edit Tests",
              component: EditTests,
            },
            {
              path: "edit-test-topic",
              name: "Edit Test Topic",
              component: EditTestTopic,
            },
            {
              path: "add-group-questions",
              name: "Add Group Questions",
              component: AddGroupQuestions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_QUESTION" },
            },
            {
              path: "add-daily-challenge",
              name: "Add Daily Challenge",
              component: AddDailyChallenge,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_DAILY_CHALLENGE" },
            },
            {
              path: "add-all-india-mock-test",
              name: "Add All India Mock Test",
              component: AddAllIndiaMockTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_ALL_INDIA_MOCK" },
            },
            {
              path: "add-recruitment-drive-test",
              name: "Add Recruitment Drive Test",
              component: AddRecruitmentDriveTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_ONGOING_RECRUITMENT" },
            },
            {
              path: "add-subscriptions",
              name: "Add Subscriptions",
              component: AddSubscriptions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_SUBSCRIPTION" },
            },
            {
              path: "add-subscription-videos",
              name: "Add Subscription Videos",
              component: AddSubscriptionVideos,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_SUBSCRIPTION" },
            },
            {
              path: "add-practice-test/:id",
              name: "Add Practice Test",
              component: AddPracticeTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_SUBSCRIPTION" },
            },
            {
              path: "add-compiler",
              name: "Add Compiler",
              component: AddCompiler,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_SUBSCRIPTION" },
            },
            {
              path: "add-mock-test/:id",
              name: "Add Mock Test",
              component: AddMockTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_SUBSCRIPTION" },
            },
            {
              path: "discussion-summary/:id",
              name: "Discussion Summary",
              component: DiscussionSummary,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_LIST_DISCUSSION" },
            },
            {
              path: "add-college",
              name: "Add College",
              component: AddCollege,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_COLLEGE" },
            },
            {
              path: "add-college-subscriptions",
              name: "Add College Subscriptions",
              component: AddCollegeSubscriptions,
            },
            {
              path: "add-notify-me",
              name: "Add Notify Me",
              component: AddNotifyMe,
            },
            {
              path: "add-notification",
              name: "Add Notification",
              component: AddNotification,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_NOTIFICATION" },
            },
            {
              path: "add-upcomming-drives",
              name: "Add Upcomming Drives",
              component: AddUpcommingDrives,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_UPCOMING_RECRUITMENT" },
            },
            {
              path: "edit-upcomming-drives/:id",
              name: "Edit Upcomming Drives",
              component: EditUpcommingDrives,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_UPCOMING_RECRUITMENT" },
            },
            {
              path: "map-subscription",
              name: "Map Subscription",
              component: MapSubscription,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_ADD_COLLEGE_SUBSCRIPTION" },
            },
            {
              path: "edit-category/:id",
              name: "Edit Category",
              component: EditCategory,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_CATEGORY" },
            },
            {
              path: "edit-state/:id",
              name: "Edit State",
              component: EditState,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_STATE" },
            },
            {
              path: "edit-banner/:id",
              name: "Edit Banner",
              component: EditBanner,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_BANNER" },
            },
            {
              path: "edit-group-question/:id",
              name: "Edit Group Question",
              component: EditGroupQuestion,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_QUESTION" },
            },
            {
              path: "edit-video/:id",
              name: "Edit Video",
              component: EditVideo,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_VIDEO" },
            },
            {
              path: "edit-college/:id",
              name: "Edit College",
              component: EditCollege,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_COLLEGE" },
            },
            {
              path: "edit-subscription/:id",
              name: "Edit Subscription",
              component: EditSubscription,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_SUBSCRIPTION" },
            },
            {
              path: "edit-admin/:id",
              name: "Edit Admin",
              component: EditAdmin,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_ADMIN" },
            },
            {
              path: "view-test-questions/:id",
              name: "View Test Questions",
              component: ViewTestQuestions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_EDIT_UPCOMING_RECRUITMENT" },
            },
            {
              path: "view-daily-test-questions/:id",
              name: "View Daily-Test Questions",
              component: ViewDailyTestQuestions,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_DAILY_CHALLENGE" },
            },
            {
              path: "view-test-questions-mock-test/:id",
              name: "View Test Questions Mock Test",
              component: ViewTestQuestionsmockTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_ALL_INDIA_MOCK" },
            },
            {
              path: "view-test-questions-practice-test/:subId/:testId",
              name: "View Test Questions Practice Test",
              component: ViewTestQuestionsPracticeTest,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
            {
              path: "view-test-questions-compiler",
              name: "View Test Questions Compiler",
              component: ViewTestQuestionsCompiler,
              beforeEnter: hasPermission,
              meta: { permission: "CAN_SEE_SUBSCRIPTION" },
            },
          ],
        },
        {
          path: "pages/auth",
          redirect: "/pages/auth/all",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "all",
              name: "Pages Auth All",
              component: PagesAuthAll,
            },
          ],
        },
        {
          path: "pages/errors",
          redirect: "/pages/errors/all",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "all",
              name: "Pages Errors All",
              component: PagesErrorsAll,
            },
          ],
        },
      ],
    },
  ],
});
